// extracted by mini-css-extract-plugin
module.exports = {"giphyLogo":"giphyContainer_giphyLogo__2TtfJ","giphyWrapper":"giphyContainer_giphyWrapper__2OWBi"};